/**
 * Base class for client-server processing
 * 
 * Helper:https://github.com/axios/axios/issues/897#issuecomment-343715381
 */
import Vue from 'vue'
import { substituteEspotoKeywords, buildKeywordContext } from '@/utils/keywords.mjs';
//import CONFIG from '@/constants/config.js';
export default class{

    static getUpdateModel(id,value){
        let newId={id:id};
        return {
          val:value,
          data:newId
        };
    }

    static getBy(attr,dataset,id){
        let res=null;
        if(dataset && attr){
            res= Vue._.find(dataset,(obj)=>{
                return obj[attr]==id
            });
        }
        return res;
    }

    static getIndexById(dataset,id){
        return Vue._.findIndex(dataset, { 'id': id });
    }

    static findGroupByGroupId(groups, groupId) {
        return groups.find(item => item.id_group === groupId);
    }

    static findTaskInGroupsByTaskId(groups, taskId) {
        let task;
        if (taskId) {
            groups.some(group => {
                task = group.tasks.find(item => item.id === taskId);
                return task
            });
        }
        return task;
    }

    static getOfflineStatistic(tasks, myStatistic) {
        // console.log("--Util_getOfflineStatistic--")

        if (tasks) {
            if (Object.keys(myStatistic).length === 0) {
                myStatistic.totalPoints = 0
                myStatistic.openPoints = 0
                myStatistic.totalTasks = 0
                myStatistic.openTasks = 0
                myStatistic.points = 0
                myStatistic.correct = 0
                myStatistic.failed = 0
                myStatistic.unfinished = 0
                // myStatistic.steps = 0

                myStatistic.taskCluster = []
            }

            tasks.forEach((task) => {
                if (Object.prototype.hasOwnProperty.call(task, 'id')) {
                    const coin = /[^/]*$/.exec(task.tbild)[0];
                    let cluster = myStatistic.taskCluster[coin]
                    if (!cluster) {
                        cluster = []
                        cluster.coin = coin
                        cluster.defaultCoinImage = task.tbild
                        cluster.taskCount = 0
                    }

                    myStatistic.totalPoints += task.points
                    myStatistic.totalTasks++
                    if (task.tstatus === 3) {
                        // correct
                        myStatistic.correct++
                        myStatistic.points += task.points
                        cluster.taskCount++
                    } else if (task.tstatus === 4) {
                        // failed
                        myStatistic.failed++
                        cluster.taskCount++
                    } else if (task.tstatus === 1 && task.checkin_time && task.checkin_time.length > 4) {
                        // unfinished
                        myStatistic.unfinished++
                    }

                    // Add hint points for unlocked hints
                    if (task.raetsel && task.raetsel.hints) {
                        // console.log("hints", task.raetsel.hints)
                        Object.values(task.raetsel.hints).forEach(hint => {
                            if (hint.timestamp && hint.points) {
                                myStatistic.points += hint.points
                            }
                        })
                    }

                    myStatistic.taskCluster[coin] = cluster
                }
            })

            myStatistic.openPoints = myStatistic.totalPoints - myStatistic.points
            myStatistic.openTasks = myStatistic.totalTasks - myStatistic.correct - myStatistic.failed
            myStatistic.taskCluster.sort((a,b) => (a.taskCount > b.taskCount) ? 1 : ((b.taskCount > a.taskCount) ? -1 : 0))
        }

        return myStatistic
    }

    /**
     * Substitutes the espoto keywords ("Storytelling Booster") in html against the
     * offline statistic, the flat spot list and the extras of eventMixin.keywordExtras
     * (remaining event time, team photo, media base data). The engine lives in
     * @/utils/keywords.mjs (balanced-bracket parser ported from the app reference).
     */
    static replaceKeywords(html, myStatistic, spots, extras) {
        if (html == null || myStatistic == null) {
            return html
        }
        return substituteEspotoKeywords(html, buildKeywordContext(myStatistic, spots, extras))
    }

    static getIndexByIdAndParam(dataset,id,param){
        let data={};
        data[param]=id;
        return Vue._.findIndex(dataset, data);
    }
    
    static addToState (state, attr,val) {
        if(!Vue._.isEmpty(val)&&!Vue._.isEmpty(attr)){
            let index=this.getIndexById(state[attr],val.id);
            if(index>-1){
                Vue.set(state[attr], index,val);
            }else{
                state[attr].push(val);
            }
        }
    }

    static deleteFromState (state, attr,val) {
        if(!Vue._.isEmpty(val)&&!Vue._.isEmpty(attr)){
            let index=this.getIndexById(state[attr],val.id);
            if(index>-1){
                Vue.delete(state[attr], index)
            }
        }
    }

    static updateOnState(state,attr, updateData){

        if(!Vue._.isEmpty(updateData) && updateData.val){

            let index=this.getIndexById(state[attr],updateData.val.id);
            if(index>-1){
                updateData.data=(updateData.data)?updateData.data:{};
                //Merge and override array
                Vue.set(state[attr], index,Vue._.mergeWith(updateData.val,updateData.data,(objValue, srcValue)=>{
                if (Vue._.isArray(srcValue)) {
                    return objValue = srcValue;
                }
                }));
            }
        }
    }
}